import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="bg-mist py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-20" data-mp="22f3erh9dfjom">
      <div className="mx-auto max-w-5xl px-4" data-id="element-21" data-mp="1yf32o39qvkkq">
        <div className="text-center" data-id="element-22" data-mp="1yc736ai90nu6">
          <span className="inline-flex items-center gap-2 rounded-full bg-solar px-4 py-2 text-xs font-extrabold uppercase tracking-[.15em] text-navy" data-id="element-23" data-mp="1annvnx70wf35">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-24" data-mp="15n9n8e1if34l" /> Included at no extra cost
          </span>
          <h2 id="bonus-title" className="mt-4 text-3xl font-extrabold text-navy sm:text-4xl" data-id="element-25" data-mp="1jilrpd5gw7yp">
            The {totalBonuses} exclusive bonuses
          </h2>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-26" data-mp="qywyo24r4mk4">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.article key={bonus.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className={`flex flex-col rounded-xl bg-navy p-6 shadow-card ${bonus.wide ? 'md:col-span-2' : ''}`} data-id="element-27" data-mp="29suz8spstt31" data-mpi={index}>
                <div className="flex items-center justify-between gap-4" data-id="element-28" data-mp="1qus55zie95yd">
                  <div className="flex items-center gap-3" data-id="element-29" data-mp="1vtd47vlwtjl8">
                    <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-leaf text-white" data-id="element-30" data-mp="20remiebihevn">
                      <Icon className="h-5 w-5" aria-hidden="true" data-id="element-31" data-mp="25q84ok1qtu25" />
                    </span>
                    <p className="text-[11px] font-extrabold uppercase tracking-[.16em] text-white/70" data-id="element-32" data-mp="3c6tu0c1cjp50">
                      Bonus {bonus.number}
                    </p>
                  </div>
                  <p className="text-xs font-bold text-white/70" data-id="element-33" data-mp="1h3f3zto47h7r">
                    <span className="line-through" data-id="element-34" data-mp="1h1kgq8pdfd0i">Real value {bonus.value}</span>
                    <span className="ml-2 rounded-md bg-solar px-2 py-1 text-[11px] font-extrabold uppercase tracking-wide text-navy" data-id="element-35" data-mp="1c3iytr3oljqm">
                      Free
                    </span>
                  </p>
                </div>

                <h3 className="mt-4 text-lg font-extrabold leading-tight text-white" data-id="element-36" data-mp="1m0nlrt5cpj8h">{bonus.title}</h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-white/80" data-id="element-37" data-mp="yajffe0s35ds">{bonus.description}</p>

                <p className="mt-4 rounded-lg border-l-4 border-leaf bg-white/10 px-4 py-3 text-sm font-semibold text-white" data-id="element-38" data-mp="1757lh6e6gr3n">
                  {bonus.benefit}
                </p>
              </motion.article>;
        })}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-5 rounded-xl border border-line bg-white px-6 py-6 text-center shadow-card sm:flex-row sm:text-left" data-id="element-39" data-mp="enltdag5kj8k">
          <div data-id="element-40" data-mp="j4oy3lv1ajz">
            <p className="text-xs font-extrabold uppercase tracking-[.18em] text-muted" data-id="element-41" data-mp="imkijp1nq0z">
              Value of all {totalBonuses} bonuses
            </p>
            <p className="mt-1 font-display text-2xl font-extrabold text-muted line-through decoration-danger decoration-2" data-id="element-42" data-mp="3mqmjwsdwxml6">
              {bonusTotalValue}
            </p>
          </div>
          <div className="sm:text-right" data-id="element-43" data-mp="3rncvb2ervu09">
            <p className="text-xs font-extrabold uppercase tracking-[.18em] text-muted" data-id="element-44" data-mp="j9mc7snxbdxy">Your price today</p>
            <p className="mt-1 font-display text-3xl font-extrabold text-leaf" data-id="element-45" data-mp="o7xmg4i4rqgp">FREE</p>
          </div>
        </div>

        <p className="mt-4 text-center text-xs font-bold uppercase tracking-[.14em] text-muted" data-id="element-46" data-mp="9b6m9t0muaq1">
          Only included in this offer
        </p>
      </div>
    </section>;
}